import { render, staticRenderFns } from "./TextBasedRole.vue?vue&type=template&id=83fa9a78&scoped=true"
import script from "./TextBasedRole.vue?vue&type=script&lang=js"
export * from "./TextBasedRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fa9a78",
  null
  
)

export default component.exports